import { Angulartics2 } from '@angularticsCompat';
import { useEffect, useRef } from 'react';
import { Subject } from 'rxjs/internal/Subject';
import { EmptySearchResultTracker } from '../../core/utils/tracking';
import useService from '../../injector/hooks/useService';

export default function useEmptyResultTracker() {
  const angulartics2 = useService(Angulartics2);
  const destroyed$ = useRef(new Subject<void>());

  const emptyResultTracker = useRef(new EmptySearchResultTracker(angulartics2, destroyed$.current));

  const onEmptyResult = (eventName, searchText, extraProps = {}) => {
    emptyResultTracker.current.onEmptyResult(eventName, searchText, extraProps);
  };

  useEffect(() => {
    return () => {
      destroyed$.current.next();
      destroyed$.current.complete();
    };
  }, []);

  return {
    onEmptyResult
  };
}
